<template>
  <div class="login-wrapper">
    <div class="login-container">
      <v-card class="login-card elevation-24">
        <!-- Header -->
        <div class="login-header">
          <v-btn
            icon
            dark
            class="back-btn"
            @click="goBack"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <div class="logo-container">
            <img
              src="/img/bice-logo.png"
              alt="Logo"
              class="logo-img"
            />
          </div>
          <h1 class="login-title">Restablecer Contraseña</h1>
          <p class="login-subtitle">Te enviaremos un correo con instrucciones</p>
        </div>

            <!-- Success Message -->
            <div v-if="successMessage" class="success-container">
              <div class="success-icon-wrapper">
                <v-icon size="80" color="#4caf50">mdi-email-check</v-icon>
              </div>

              <h2 class="success-title">¡Correo enviado!</h2>
              <p class="success-message">{{ successMessage }}</p>
              <p class="success-hint mt-3">
                Revisa tu bandeja de entrada y la carpeta de spam.
              </p>

              <v-btn
                x-large
                block
                color="#28385C"
                dark
                @click="goBack"
                class="login-btn mt-6"
                elevation="2"
              >
                <v-icon left>mdi-arrow-left</v-icon>
                Volver al inicio de sesión
              </v-btn>
            </div>

            <!-- Form -->
            <v-card-text v-if="!successMessage" class="login-form-container">
              <v-form ref="form" v-model="valid" @submit.prevent="sendResetEmail">
                <p class="mb-4 text-body-2 grey--text text--darken-1">
                  Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
                </p>

                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="Correo Electrónico"
                  name="email"
                  prepend-inner-icon="mdi-email-outline"
                  type="email"
                  required
                  :disabled="loading"
                  outlined
                  dense
                  class="mb-4"
                  color="#28385C"
                  autofocus
                ></v-text-field>

                <div
                  v-if="errorMessage"
                  style="color: #d32f2f; padding: 12px 0; margin-bottom: 16px; font-size: 14px; text-align: center;"
                >
                  {{ errorMessage }}
                </div>

                <v-btn
                  block
                  x-large
                  color="#28385C"
                  dark
                  :loading="loading"
                  :disabled="!valid || loading"
                  @click="sendResetEmail"
                  class="login-btn mb-3"
                  elevation="2"
                >
                  <v-icon left>mdi-email-send</v-icon>
                  Enviar instrucciones
                </v-btn>

                <v-btn
                  block
                  text
                  color="#28385C"
                  @click="goBack"
                  :disabled="loading"
                  class="cancel-btn"
                >
                  Cancelar
                </v-btn>
              </v-form>
            </v-card-text>

        <!-- Footer -->
        <v-divider v-if="!successMessage"></v-divider>
        <div v-if="!successMessage" class="login-footer">
          <p class="footer-text">
            <v-icon small color="#666">mdi-shield-check</v-icon>
            Conexión segura y encriptada
          </p>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "ForgotPassword",
  data() {
    return {
      valid: false,
      email: "",
      loading: false,
      errorMessage: "",
      successMessage: "",
      emailRules: [
        v => !!v || "El correo electrónico es requerido",
        v => /.+@.+\..+/.test(v) || "El correo electrónico debe ser válido"
      ]
    };
  },
  methods: {
    async sendResetEmail() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      this.errorMessage = "";
      this.successMessage = "";

      try {
        const response = await this.axios.post(
          `${process.env.VUE_APP_API_URL}/forgot_password`,
          { email: this.email },
          {
            validateStatus: function (status) {
              return status < 500;
            }
          }
        );

        if (response.status === 200 && response.data && response.data.success) {
          this.successMessage = response.data.message ||
            "Revisa tu correo electrónico para continuar con el proceso.";
        } else {
          this.errorMessage = (response.data && response.data.message) ||
            "No se pudo enviar el correo. Intenta nuevamente.";
          this.autoClearError();
        }
      } catch (error) {
        if (error.response) {
          this.errorMessage = "Error del servidor. Por favor, intenta más tarde.";
        } else if (error.request) {
          this.errorMessage = "No se pudo conectar con el servidor. Verifica tu conexión a internet.";
        } else {
          this.errorMessage = "Error al procesar la solicitud. Por favor, intenta nuevamente.";
        }
        this.autoClearError();
      } finally {
        this.loading = false;
      }
    },
    autoClearError() {
      if (this._errorTimer) clearTimeout(this._errorTimer);
      this._errorTimer = setTimeout(() => {
        this.errorMessage = "";
      }, 5000);
    },
    goBack() {
      this.$router.push("/login_standard").catch(() => {});
    }
  }
};
</script>

<style scoped>
.login-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  z-index: 9999;
}

.login-container {
  min-height: 100vh;
  padding: 40px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  border-radius: 16px;
  overflow: hidden;
  background: #ffffff;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}

.login-header {
  background: #28385C;
  padding: 40px 40px 36px;
  text-align: center;
  color: white;
  position: relative;
}

.back-btn {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 1;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.logo-img {
  width: 140px;
  height: auto;
  object-fit: contain;
}

.login-title {
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
}

.login-subtitle {
  font-size: 15px;
  margin: 0;
  opacity: 0.9;
  font-weight: 300;
}

.login-form-container {
  padding: 40px !important;
}

.login-btn {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: none;
  border-radius: 10px;
  height: 56px !important;
  transition: all 0.3s ease;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(40, 56, 92, 0.25) !important;
}

.cancel-btn {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
}

.login-footer {
  padding: 20px 40px;
  text-align: center;
  background: #f8f9fa;
}

.footer-text {
  margin: 0;
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

/* Success Container */
.success-container {
  padding: 50px 40px;
  text-align: center;
}

.success-icon-wrapper {
  margin-bottom: 20px;
  animation: successPulse 0.6s ease-out;
}

@keyframes successPulse {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.success-title {
  font-size: 26px;
  font-weight: 600;
  color: #28385C;
  margin: 0 0 12px 0;
  letter-spacing: -0.5px;
}

.success-message {
  font-size: 15px;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

.success-hint {
  font-size: 13px;
  color: #999;
  margin: 0;
}

/* Tablet */
@media (max-width: 768px) {
  .login-container {
    padding: 30px 16px;
  }

  .login-card {
    max-width: 460px;
  }

  .login-header {
    padding: 36px 32px 32px;
  }

  .logo-img {
    width: 130px;
  }

  .login-title {
    font-size: 26px;
  }

  .login-subtitle {
    font-size: 14px;
  }

  .login-form-container {
    padding: 32px !important;
  }

  .login-footer {
    padding: 18px 32px;
  }

  .success-container {
    padding: 40px 32px;
  }
}

/* Mobile */
@media (max-width: 480px) {
  .login-container {
    padding: 20px 16px;
  }

  .login-card {
    border-radius: 12px;
  }

  .login-header {
    padding: 28px 24px 24px;
  }

  .back-btn {
    top: 8px;
    left: 8px;
  }

  .logo-img {
    width: 110px;
  }

  .login-title {
    font-size: 22px;
  }

  .login-subtitle {
    font-size: 13px;
  }

  .login-form-container {
    padding: 24px !important;
  }

  .login-btn {
    height: 52px !important;
    font-size: 15px;
  }

  .cancel-btn {
    font-size: 13px;
  }

  .login-footer {
    padding: 16px 24px;
  }

  .footer-text {
    font-size: 12px;
  }

  .success-container {
    padding: 32px 24px;
  }

  .success-title {
    font-size: 22px;
  }

  .success-message {
    font-size: 14px;
  }

  .success-hint {
    font-size: 12px;
  }
}
</style>
